
$(".megamenu-parent-link:not(.no-children)").click(function (e) {
  e.preventDefault();
  var $parent = $(this).parents(".header-bottom-nav-item");
  var $list_parent = $parent.parents("ul");

  if ($(this).hasClass("active")) {
    megaMenuClose();
  } else {
    megaMenuClose();

    $parent.addClass("active");
    $parent.find(".megamenu-parent-link").attr("aria-expanded", "true");
    $("html").addClass("mega-menu--open");
    $list_parent.addClass("has-active");
  }
});

$(".megamenu-close-button").click(function (e) {
  e.preventDefault();
  megaMenuClose();
});

function megaMenuClose() {
  $("html").removeClass("mega-menu--open");
  var $activeItems = $(".header-bottom-nav-item.active");
  var $list_parent = $(".header-bottom-nav-ul");

  $list_parent.removeClass("has-active");
  $activeItems.removeClass("closing");
  $activeItems.removeClass("active");
  $(".megamenu-parent-link").attr("aria-expanded", "false");

  //dirty hack for accessibe to close the megamenu
  $activeItems.trigger("click");

  setTimeout(function () {}, 300);
}





$(".parent_has_submenu").click(function (e) {
  var $parent = $(this).parents(".fixed-nav-menu-item");
  e.preventDefault();
  if ($parent.hasClass("active")) {
    $parent.removeClass("active");
    $(this).attr("aria-expanded", "false");
  } else {
    $("#fixed-menu").addClass("submenu-open");
    var $btn = $(this);
    setTimeout(function () {
      $parent.addClass("active");
    }, 100);
    $btn.attr("aria-expanded", "true");
    $(".header-content .toggle-menus").hide();
  }
});

// role="button" elements must also activate on Space (anchors only fire click on Enter)
$(".parent_has_submenu").on("keydown", function (e) {
  if (e.key === " " || e.keyCode === 32) {
    e.preventDefault();
    $(this).click();
  }
});

// A11y: the in-menu skip link must actually MOVE focus to the nav list (an in-page
// href alone only scrolls; it does not move screen-reader/keyboard focus).
$(document).on("click", ".js-skip-to-menu", function (e) {
  e.preventDefault();
  var list = document.getElementById("fixed-nav-menu-list");
  if (!list) return;
  var firstItem = list.querySelector("a, button");
  (firstItem || list).focus();
});

function fixedNavSubMenuClose() {
  var $active_nav = $(".fixed-nav-menu-item.active");

  $active_nav.find(".parent_has_submenu").attr("aria-expanded", "false");
  $active_nav.addClass("closing");
  setTimeout(function () {
    $("#fixed-menu").removeClass("submenu-open");
    $(".fixed-nav-menu-list").focus();
    $active_nav.removeClass("closing");
    $active_nav.removeClass("active");
    $(".header-content .toggle-menus").show();
  }, 800);
}

$(".js-fixed-nav-back").click(function (e) {
  console.log("helloasdas");
  fixedNavSubMenuClose();
});


//header logo video
$(document).ready(function () {
  const video = document.querySelector(".logo-video-container video");

  const videoContainerEl = document.querySelector(".logo-video-container");

  if (video) {
    video.addEventListener(
      "loadeddata",
      function (e) {
        playLogoVideo();
      },
      false
    );

    video.addEventListener(
      "canplay",
      function (e) {
        playLogoVideo();
      },
      false
    );

    video.addEventListener(
      "canplaythrough",
      function (e) {
        playLogoVideo();
      },
      false
    );

    video.addEventListener("ended", function () {
      //console.log("video ended");
      //videoContainerEl.classList.remove("video-loaded");
    });

    playLogoVideo();

    video.removeAttribute("controls");
  }

  function playLogoVideo() {
    video.play();
    //console.log("play");
    setTimeout(function () {
      videoContainerEl.classList.add("video-loaded");
    }, 500);
  }

  $(".nav-menu.recent-additions").each(function () {
    var handle = $(this).data("handle");
    var _this = $(this);
    let url = window.Shopify.routes.root + "collections/" + handle + "?view=alternate&sort_by=created-descending";

    $.ajax({
            type: "GET",
            url: url,
            success: function (result) {
            var json = JSON.parse(result);
            let limit = 3;
            let cls = "link-animate-underline";
            if (_this.hasClass("fixed-nav-submenu-item-list")) {
                cls = "";
            }
            for (let i = 0; i < limit && i < json.products.length; i++) {
                let product = json.products[i];
                var item = `<li class="megamenu-grandchild-item"><a class="${cls}" href="${product.url}">${product.title}</a></li>`;
                _this.append(item);
            }
            },
            error: function () {
            _this.hide();
            },
        });
    });

    $(".nav-menu.best-sellers").each(function () {
    var handle = $(this).data("handle");
    var _this = $(this);
    let url = window.Shopify.routes.root + "collections/" + handle + "?view=alternate&sort_by=best-selling";
    $.ajax({
            type: "GET",
            url: url,
            success: function (result) {
            var json = JSON.parse(result);
            let limit = 5;
            let cls = "link-animate-underline";
            if (_this.hasClass("fixed-nav-submenu-item-list")) {
                cls = "";
            }
            
            for (let i = 0; i < limit && i < json.products.length; i++) {
                let product = json.products[i];
                var item = `<li class="megamenu-grandchild-item"><a class="${cls}" href="${product.url}">${product.title}</a></li>`;
                _this.append(item);
            }

            /*hide parent link if products == 0 
            if(json.products.length == 0){
                _this.parents('.header-bottom-nav-item').hide();
                _this.parents('.fixed-nav-menu-item').hide();
            }
            */
            },
            error: function () {
            _this.hide();
            },
        });
    });
});